<template>
  <DBox
    :id="'cmp-catalog-releases-sidewindow-artwork'"
    :addButton="false"
    :addLink="false"
    @add_click="onAddArtist"
  >
    <div class="flex-container">
      <ArtworkBox
        :fileId="artwork1"
        :buttonText="$t('add_front_side')"
        @addSide="onFrontAdd"
        @removeSide="(e) => onFrontRemove('front')"
      />
      <ArtworkBox
        :fileId="artwork2"
        :buttonText="$t('add_back_side')"
        @addSide="onBackAdd"
        @removeSide="(e) => onBackRemove('back')"
      />
    </div>
    <!-- <ModalContainer
      :modalKey="'artworkUploader'"
      :width="'medium'"
    >
      <ArtworkUploader @cancelled="artworkUploaderCancelled" />
    </ModalContainer> -->
    <template v-if="artworkUploaderModalContainer">
      <v-dialog :value="artworkUploaderModal" persistent width="562">
        <ArtworkUploader
          :artwork="side == 'front' ? artwork1 : side == 'back' ? artwork2 : ''"
          :externalId="externalId"
          :externalTable="externalTable"
          :externalKey="externalKey"
          :section="section"
          @artworkChanged="onArtworkChanged"
          @ok="onOKClicked"
          @done="onDoneClicked"
          @cancelled="onModalCancelled"
        />
      </v-dialog>
    </template>
  </DBox>
</template>
<script>
import DBox from "@dtplugins/dbox/dbox";
import ModalContainer from "@dtplugins/modal/modal-container";

import ArtworkBox from "./artwork-box";
import ArtworkUploader from "./artwork-uploader";
import {
  closeModalRoute,
  createModalMixin,
  openModalRoute,
} from "../modal/modal.mixin";

export default {
  components: {
    DBox,
    ModalContainer,
    ArtworkBox,
    ArtworkUploader,
  },
  props: {
    artwork1: {
      type: String,
    },
    artwork2: {
      type: String,
    },
    externalId: {
      required: true,
    },
    externalTable: {
      required: true,
    },
    externalKey: {
      required: true,
    },
    section: {
      required: true,
    },
  },
  data: function () {
    return {};
  },
  mixins: [createModalMixin("artworkUploader")],
  computed: {
    side() {
      return this.$route.query.side;
    },
    sideInfo() {
      const artworkKey =
        this.side == "front"
          ? "artwork1"
          : this.side == "back"
          ? "artwork2"
          : undefined;
      return {
        side: this.side,
        artworkKey,
      };
    },
  },
  methods: {
    onAddArtist: function () {},
    onFrontAdd: function () {
      openModalRoute(this, "artwork_uploader", {
        side: "front",
      });
    },
    onBackAdd: function () {
      openModalRoute(this, "artwork_uploader", {
        side: "back",
      });
    },
    onModalCancelled: function () {
      closeModalRoute(this, {
        side: undefined,
      });
    },
    onArtworkChanged: function (file) {
      this.$emit("artworkChanged", {
        file,
        ...this.sideInfo,
      });
    },
    onOKClicked: function () {
      this.onModalCancelled();
    },
    onDoneClicked: function (payload) {
      this.$emit("done", { ...payload, ...this.sideInfo });
      this.onModalCancelled();
    },
    onFrontRemove: function (side) {
      this.$emit("artworkChanged", {
        artworkKey: this.fromSideToKey(side),
      });
    },
    onBackRemove: function (side) {
      this.$emit("artworkChanged", {
        artworkKey: this.fromSideToKey(side),
      });
    },
    fromSideToKey: function (side) {
      return side == "front" ? "artwork1" : "artwork2";
    },
    //MARK: Methods
  },
};
</script>
<style lang="scss">
.cmp-catalog-releases-sidewindow-artwork {
  .dt-ntable {
    --ntable-height: 170px;
  }
  .flex-container {
    display: flex;
    height: 100%;
  }
}
</style>
